module.exports = __webpack_public_path__ + "img/circles.dafa4436.gif";